<template>
  <div class="content">
    <div class="content__wrapper">
      <div class="content__title">
        <h1 class="text-brown">{{ title }}</h1>
      </div>

      <div class="content__text w-full leading-tight">
        <p>
          Un projet, un besoin, une idée, un souhait, pensez à CORBET et venez
          partager avec notre équipe.
        </p>

        <p>
          Nous vous écouterons, vous conseillerons et vous accompagnerons pour
          vous apporter un haut niveau de service.
        </p>

        <p class="md:mb-0">
          Notre entreprise et le groupe FIROPA auquel nous appartenons sont en
          mesure :
        </p>

        <ul class="list-disc list-inside">
          <li v-for="introList in introLists" :key="introList.item">
            {{ introList.item }}
          </li>
        </ul>

        <p>
          CORBET, votre partenaire unique en gestion documentaire, communication
          visuelle, produits imprimés et services associés.
        </p>

        <div
          class="flex w-full flex-col md:flex-row items-center md:items-stretch justify-between"
        >
          <mes-fiches
            v-for="fiche in fiches"
            :key="fiche.path"
            :ficheInfos="fiche"
          ></mes-fiches>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mesFiches from '../components/Fiche'

export default {
  components: {
    mesFiches
  },
  data () {
    return {
      title: 'SERVICES ET IMPRESSION',
      introLists: [
        {
          item: 'de répondre à la majorité de vos besoins de produits imprimés,'
        },
        {
          item:
            'de vous accompagner pour rationaliser vos process sur-mesure grâce à des outils informatiques pertinents,'
        },
        {
          item: 'de lier le papier au web.'
        }
      ],
      fiches: [
        {
          path: '/static/icons/gestion-documentaire.png',
          title: 'Gestion Documentaire',
          bgColor: 'bg-maquamarine',
          bgColorText: 'bg-maquamarine--92',
          ficheItems: [
            {
              item: 'Services informatiques intégrant un portail de commande, l\'informatique éditoriale, la gestion de base documentaire, la diffusion digitale, le papier connecté, la numérisation, etc,'
            },
            {
              item: 'La production graphique avec façonnage intégré,'
            },
            {
              item: 'La gestion logistique.'
            }
          ]
        },
        {
          path: '/static/icons/document-imprimes.png',
          title: 'Réalisation de documents imprimés',
          bgColor: 'bg-sandybrown',
          bgColorText: 'bg-sandybrown--92',
          ficheItems: [
            {
              item: 'Reprographie, Plans, dossiers, PLU…'
            },
            {
              item: 'Cartes de visites, papier entête, enveloppes, pochettes,'
            },
            {
              item: 'Livres, brochures, dépliants, blocs,'
            },
            {
              item: 'Notices, supports formation,'
            },
            {
              item: 'Mailings, documents personnalisés,'
            },
            {
              item: 'Impression à la demande.'
            }
          ]
        },
        {
          path: '/static/icons/communication.png',
          title: 'Communication Visuelle / Signalétique',
          bgColor: 'bg-mturquoise',
          bgColorText: 'bg-mturquoise--92',
          ficheItems: [
            {
              item: 'Affichage intérieur et extérieur,'
            },
            {
              item: 'Habillage d’intérieur, d’extérieur, de vitrines et sols,'
            },
            {
              item: 'Panneaux rigides,'
            },
            {
              item: 'Vitrophanie (blanc couvrant),'
            },
            {
              item: 'Habillage stands, Roll’up, bâches, Kakémonos, banderoles,'
            },
            {
              item: 'Lettrage, stickers,'
            },
            {
              item: 'Papier peint personnalisé.'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="css" scoped>
@media screen and (min-width: 768px) {
  .content {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Accueil.vue